const contentType = {
  Article: 'Article',
  Podcast: 'Podcast',
  Video: 'Video',
  Webinar: 'Webinar'
};

export const transcriptSupportedContentTypes = [
  contentType.Podcast,
  contentType.Video,
  contentType.Webinar
];

export const searchTileTypeFilter = {
  ...contentType,
  Course: 'Course',
  Event: 'Event'
};

export const externalActivityType = {
  ...contentType,
  Course: 'Course',
  Presentation: 'Presentation',
  Event: 'Event',
  FormalEducation: 'FormalEducation',
  CreatingAndConductingCPDTraining: 'CreatingAndConductingCPDTraining',
  Other: 'Other'
};

export const contentIcons = {
  Article: 'content-large',
  Podcast: 'audio-large',
  Video: 'video-large',
  Webinar: 'presentation-large',
  Course: 'associations-large',
  Presentation: 'messages',
  Event: 'event-large',
  Other: 'other-large',
  ExternalCpd: 'external-cpd'
};

export default contentType;



// WEBPACK FOOTER //
// ./src/constants/content-type.js